import React from 'react';

export default function TeamTileIndicators(props) {
    const { activeTile, onClick, team } = props;

    return (
        <div className="indicators">
            {Object.keys(team).map((item, key) => {
                return (
                    <div
                        key={key}
                        className={`indicator${key === activeTile ? ' active' : ''}`}
                        onClick={() => onClick(key)}
                    />
                )
            })}
        </div>
    )
}
